export const ROUTE_KEYS = ['presentationbuilder', 'preview', 'broker'];

// export const DEAL_ID = '2329'; //production id
export const DEAL_ID = '6313'; //local id

export const IS_SHORTLISTED = 'isShortlisted';
export const PHOTOS = 'PHOTOS';
export const FLOOR_PLAN = 'FLOOR_PLAN';
export const IMAGE_PRE_TEXT = 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2F';

export const DEVICE_SIZES = {
  tablet: 768,
  desktop: 1224,
};

export const DEVICE_MEDIA = {
  SMALL_MOBILE_MAX: `(max-width: 600px)`,
  MOBILE_MAX: `(max-width: ${DEVICE_SIZES.tablet - 1}px)`,
  TABLET_MIN: `(min-width: ${DEVICE_SIZES.tablet}px)`,
  DESKTOP_MIN: `(min-width: ${DEVICE_SIZES.desktop}px)`,
};

export const DEVICE_ORIENTATION = {
  POTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
};

export const EMAIL_TEMPLATES_ID = {
  SHORT_LIST: process.env.REACT_APP_SHORTLIST_EMAIL_SENGRID_TEMPLATE_ID.trim(),
  TOUR_REQUEST: process.env.REACT_APP_TOUR_REQUEST_SENGRID_TEMPLATE_ID.trim(),
  PROPOSAL_REQUEST: process.env.REACT_APP_AGREEMENT_REQUEST_SENGRID_TEMPLATE_ID.trim(),
  CLIENT_QUERY_REQUEST: process.env.REACT_APP_QUERY_TEMPLATE_ID.trim(),
};
